import styled from 'styled-components';
export const SkipWrapper = styled.div `
  .skip-link {
    clip: rect(1px, 1px, 1px, 1px);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;

    &:focus {
      outline: var(--border-width-thin) solid var(--color-neutral-130);
      box-shadow: 0 0 0 2px var(--color-neutral-70);
      clip: initial;
      height: 50px;
      overflow: initial;
      white-space: initial;
      width: 60px;
      color: var(--color-neutral-130);
      background-color: var(--color-neutral-70);
      display: inline-block;
      z-index: 2;
      top: 50%;
      transform: translateY(-50%);
      left: 0;
    }
  }
`;
